import { MutableValue } from "@/modules/api/mutable-value.interface";

import { FactoryInvoiceStatusValue } from "./factory-invoice-status.value";
import { FactoryInvoiceTypeValue } from "./factory-invoice-type.value";

export default class BatchInvoiceSummary implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fIncrementalId: string | undefined,
    private fCreatedAt: Date,
    private fFactory: string,
    private fItemsQty: number,
    private fTotal: number,
    private fStatus: FactoryInvoiceStatusValue,
    private fType: FactoryInvoiceTypeValue,
    private fUsedDepositPercent: number | undefined,
    private fBatchPlushieId: string,
    private fBulkProjectId: string,
    private fBulkProjectSku?: string,
    private fBatchPlushieSku?: string
  ) {
    [
      fId,
      fCreatedAt,
      fFactory,
      fItemsQty,
      fTotal,
      fStatus,
      fType,
      fBatchPlushieId,
      fBulkProjectId,
    ].forEach((arg, index) => {
      if (arg === undefined || arg === null) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get incrementalId(): string | undefined {
    return this.fIncrementalId;
  }

  get number(): string | undefined {
    return this.fIncrementalId;
  }

  get createdAt(): Date {
    return this.fCreatedAt;
  }

  get factory(): string {
    return this.fFactory;
  }

  get factoryId(): string {
    return this.fFactory;
  }

  get itemsQty(): number {
    return this.fItemsQty;
  }

  get total(): number {
    return this.fTotal;
  }

  get status(): FactoryInvoiceStatusValue {
    return this.fStatus;
  }

  get type(): FactoryInvoiceTypeValue {
    return this.fType;
  }

  get usedDepositPercent(): number | undefined {
    return this.fUsedDepositPercent;
  }

  get bulkProjectSku(): string | undefined {
    return this.fBulkProjectSku;
  }

  get batchPlushieSku(): string | undefined {
    return this.fBatchPlushieSku;
  }

  get batchPlushieId(): string {
    return this.fBatchPlushieId;
  }

  get bulkProjectId(): string {
    return this.fBulkProjectId;
  }
}
